export default function ZHBMeeting() {
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button className="accordion-button caret-off collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseZHBMeeting">
          <div className="custom-button-layout">
            <img className="day-icon" src="../img/cal-icons/october-5-icon.png" alt="October 5 Calendar Icon" />
            <b>CANCELED: Zoning Hearing Board Meeting</b>
            <span className="badge bg-danger">CANCELED</span>
            {/*      <span className="badge bg-primary badge-custom">Meeting</span>  */}
          </div>
        </button>
      </h2>
      <div id="collapseZHBMeeting" className="accordion-collapse collapse" data-bs-parent="#upcomingEventsAccordion">
        <div className="accordion-body">
          <p>
            The meeting scheduled for October 5, 2026 has been canceled.
            {/*  Monday, June 1, 2026 at 7:00 p.m.<br /> 
            <a href="https://maps.app.goo.gl/uB7NMgLow9j2wTka6">
              <i className="fa-solid fa-location-pin"></i>&nbsp;Morrisville Borough Hall (35 Union St.)
            </a>
            */}
          </p>
        </div>
      </div>
    </div>
  );
}
